import { render, staticRenderFns } from "./CreditosModal.vue?vue&type=template&id=65fcdde7&scoped=true"
import script from "./CreditosModal.vue?vue&type=script&lang=js"
export * from "./CreditosModal.vue?vue&type=script&lang=js"
import style0 from "./CreditosModal.vue?vue&type=style&index=0&id=65fcdde7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fcdde7",
  null
  
)

export default component.exports